module.exports = __webpack_public_path__ + "static/media/link_warning_yl.19a5c6ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link_warning_yl.svg
// module id = 159
// module chunks = 0